import React from "react";
import { useHistory } from "react-router-dom";
import user from "../../static/images/user_default.png";

const ComunidadKrezco = ({ data }) => {
  let history = useHistory();

  function setLinkCandidato(item) {
    let rol = localStorage.getItem("rol");
    switch (rol) {
      case "applicant":
        history.push({
          pathname: "/user/Candidato/",
          state: { userid: item },
        });
        break;
      case "company":
        history.push({
          pathname: "/company/Candidato/",
          state: { userid: item },
        });
        break;
      case "institute":
        history.push({
          pathname: "/CentroFormacion/Candidato",
          state: { userid: item },
        });
        break;

      default:
        break;
    }
  }

  return data.length === 0 ? (
    <div>Cargando...</div>
  ) : (
    data.map((item, index) => (
      <div>
        <div key={index} className="img-community border-purple">
          <img
            src={item.image != null ? item.image : user}
            alt="comunidad"
            style={{
              width: "59px",
              height: "59px",
              borderRadius: "8px",
              backgroundImage: `url(${user})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
            }}
            onClick={() => setLinkCandidato(item.applicantProfileId)}
            type="button"
          ></img>
          <br></br>
        </div>

        <div className="content-info-card">
          <span
            className="title"
            onClick={() => setLinkCandidato(item.applicantProfileId)}
            type="button"
          >
            {item.names + " " + item.lastnames}
          </span>
          <br></br>
          <span className="sub-title" style={{ height: "auto" }}>
            {item.profession}
          </span>

          {/*   <a
            className="sub-title fw-semi-bold link-purple "
            style={{ height: "0px", fontSize: "12px" }}
            onClick={() => setLinkCandidato(item.applicantProfileId)}
            type = "button"
          
            Ver
          </a>
          >*/}
        </div>
      </div>
    ))
  );
};

export default ComunidadKrezco;
